import { useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { amenities } from "../data/project";

export default function Amenities() {
  const [active, setActive] = useState(0);
  const current = amenities[active];
  const change = (direction) => setActive((value) => (value + direction + amenities.length) % amenities.length);

  return (
    <>
      <div className="amenity-viewer">
        <div className="amenity-image-wrap">
          <AnimatePresence mode="wait">
            <motion.img
              key={current.image}
              src={current.image}
              alt={`${current.title} do La Courbe Tower`}
              loading="lazy"
              initial={{ opacity: 0.2, scale: 1.02 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0.2 }}
              transition={{ duration: 0.38 }}
            />
          </AnimatePresence>
          <span>Imagem meramente ilustrativa</span>
        </div>
        <div className="amenity-content">
          <p className="amenity-index"><span>{String(active + 1).padStart(2, "0")}</span> / {String(amenities.length).padStart(2, "0")}</p>
          <h3>{current.title}</h3>
          <p>{current.description}</p>
          <div className="amenity-controls">
            <button type="button" onClick={() => change(-1)} aria-label="Espaço anterior"><ArrowLeft aria-hidden="true" /></button>
            <button type="button" onClick={() => change(1)} aria-label="Próximo espaço"><ArrowRight aria-hidden="true" /></button>
          </div>
        </div>
      </div>
      <div className="amenity-rail">
        {amenities.map((item, index) => (
          <button
            type="button"
            className={index === active ? "is-active" : ""}
            key={item.title}
            onClick={() => setActive(index)}
          >
            {item.title}
          </button>
        ))}
      </div>
    </>
  );
}
